import { render, staticRenderFns } from "./DetailsRollover.vue?vue&type=template&id=54d837ee&"
import script from "./DetailsRollover.vue?vue&type=script&lang=js&"
export * from "./DetailsRollover.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports